import { useEffect } from 'react';

import { FormControl } from '@chakra-ui/react';

import DateField from 'components/fields/DateField';

import SharedMessage from '../Message/SharedMessage';

import { useAppDispatch } from 'hooks';

import useFormBinderDisabled from 'hooks/useFormBinderDisabled';

import { SharedDateInputProps } from './DateInput.types';

const SharedDateInput = ({
  label,
  date,
  onChange,
  section,
  formStateKey,
  formActions,
  required,
  message,
  subLabel,
  disabled = false,
  isClearable = false,
}: SharedDateInputProps) => {
  const dispatch = useAppDispatch();

  const htmlID = subLabel ? `${label} (${subLabel})` : label;
  const isDisabled = useFormBinderDisabled(formStateKey, disabled);

  useEffect(() => {
    if (!required) return;

    if (date === null) {
      dispatch(formActions.addMissingMandatoryField({ name: htmlID, section }));
    } else {
      dispatch(formActions.removeMissingMandatoryField(htmlID));
    }
  }, [required, date, htmlID, section, dispatch, formActions]);

  return (
    <FormControl>
      <DateField
        label={label}
        date={date}
        onChange={(e: Date) => onChange(e)}
        required={required}
        htmlID={htmlID}
        isDisabled={isDisabled}
        isClearable={isClearable}
      />

      {message && (
        <SharedMessage
          {...message}
          section={section}
          formStateKey={formStateKey}
          formActions={formActions}
        />
      )}
    </FormControl>
  );
};

export default SharedDateInput;
